module.exports = __webpack_public_path__ + "static/media/Codescape.a1a9a360.png";